import { css } from '@emotion/react';
import type { ReactElement } from 'react';

import { styled } from '../../../../../../styled';
import { Theme } from '../../../../../../theme/interface/detailed';
import { useTheme } from '../../../../../../theme/useTheme';

const Component = (props: { className: string; onClick: VoidFunction }): ReactElement => {
	const theme = useTheme();
	return (
		<svg
			{...props}
			width={parseInt(theme.chat.icons.deleteAttachmentIcon.width + '')}
			height={parseInt(theme.chat.icons.deleteAttachmentIcon.height + '')}
			viewBox="0 0 18 22"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 18C9.45 18 9 17.55 9 17V11C9 10.45 9.45 10 10 10C10.55 10 11 10.45 11 11V17C11 17.55 10.55 18 10 18ZM15 17V11C15 10.45 14.55 10 14 10C13.45 10 13 10.45 13 11V17C13 17.55 13.45 18 14 18C14.55 18 15 17.55 15 17ZM21 7C21 7.55 20.55 8 20 8H19V19C19 20.65 17.65 22 16 22H8C6.35 22 5 20.65 5 19V8H4C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6H8V5C8 3.35 9.35 2 11 2H13C14.65 2 16 3.35 16 5V6H20C20.55 6 21 6.45 21 7ZM10 6H14V5C14 4.45 13.55 4 13 4H11C10.45 4 10 4.45 10 5V6ZM17 8H7V19C7 19.55 7.45 20 8 20H16C16.55 20 17 19.55 17 19V8Z"
				fill={theme.chat.icons.deleteAttachmentIcon.fill}
			/>
		</svg>
	);
};

export const DeleteAttachmentIcon = styled(Component)(
	({
		theme: {
			chat: {
				icons: {
					deleteAttachmentIcon: { height, width },
				},
			},
		},
	}: {
		theme: Theme;
	}) =>
		css`
			min-width: ${width};
			min-height: ${height};
			cursor: pointer;
			float: right;
		`
);
export const AngleDownIcon = styled(Component)(
	({
		theme: {
			allSettings: {
				icons: { angleDownIcon },
			},
		},
	}: {
		theme: Theme;
	}) =>
		css`
			align-items: center;
			cursor: pointer;
			display: flex;
			height: 100%;
			${angleDownIcon}
		`
);
